var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardHeader',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.infoText)?_c('span',[_c('CIcon',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:({
          content: _vm.infoText,
          color:'primary',
          placement:'top',
          boundaries: 'window'
        }),expression:"{\n          content: infoText,\n          color:'primary',\n          placement:'top',\n          boundaries: 'window'\n        }"}],staticClass:"info-icon",attrs:{"name":"md-info"}})],1):_vm._e()]),_c('CCardBody',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }